import { render, staticRenderFns } from "./UsBankFailures.vue?vue&type=template&id=2b4128d6&scoped=true"
import script from "./UsBankFailures.vue?vue&type=script&lang=js"
export * from "./UsBankFailures.vue?vue&type=script&lang=js"
import style0 from "./UsBankFailures.vue?vue&type=style&index=0&id=2b4128d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4128d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VLazy,VRow})
